import { HttpRequest } from "./HttpRequest";
import { HttpService } from '../services/http-service';
import { apiUrl } from './Defaults';
import {uuid} from "../helpers/uuid";
import {LocalstorageService} from "../services/localstorage-service";
import {narAppStorageKey} from "../constants/session-storage/auth";

export class SublocacaoAPI {
  constructor() {
    this._url = `${apiUrl}/sublocacao`;
    this._httpRequest = new HttpRequest();
    this.getReserva = this.getReserva.bind(this);
    this.saveReserva = this.saveReserva.bind(this);
    this.getAll = this.getAll.bind(this);

  }

  async getReserva(documentNumber) {
    if (!documentNumber) {
      throw new Error('Reserva é obrigatório');
    }

    const authenticatedUserData = LocalstorageService.getData(narAppStorageKey);

    return await this._httpRequest.authGet(`${this._url}/${documentNumber}?cpf=${authenticatedUserData.cpf}&store=${authenticatedUserData.store}`);
  }


  async saveReserva(subLocacaoDto) {

    if (!subLocacaoDto.numeroReserva) {
      throw new Error('Reserva é obrigatório');
    }
    
    console.log("Dados Enviados :", subLocacaoDto)

    return await this._httpRequest.authPost(`${this._url}/${subLocacaoDto.numeroReserva}`, subLocacaoDto)
    //return await this._httpRequest.authPost(`${this._url}/${subLocacaoDto.numeroFormManual}`)
  }


  async getAll(subLocacaoDto) {
    if (!subLocacaoDto) {
      throw new Error('Reserva é obrigatório');
    }

    const authenticatedUserData = LocalstorageService.getData(narAppStorageKey);
    subLocacaoDto.numeroReserva = subLocacaoDto.numeroReserva ? subLocacaoDto.numeroReserva : null;
    subLocacaoDto.numeroFormManual = subLocacaoDto.numeroFormManual ? subLocacaoDto.numeroFormManual : null;
    subLocacaoDto.lojaCedente = subLocacaoDto.lojaCedente ? subLocacaoDto.lojaCedente : null;
    subLocacaoDto.lojaSolicitante = subLocacaoDto.lojaSolicitante ? subLocacaoDto.lojaSolicitante : null;

    const queryStrings = HttpService.generateQueryStrings(subLocacaoDto);


    console.log(subLocacaoDto)

    //return await this._httpRequest.authGet(`${this._url}`);
    return await this._httpRequest.authGet(`${this._url}?${queryStrings}`);

  }

  
}

export default new SublocacaoAPI();
